module.exports = __webpack_public_path__ + "img/progress_076.3a9e5a58.png";